// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { EventDetailsResponse, getEventDetails } from "@werner/App/Services/EventDetailsService";

interface Props {
    apiResult: EventDetailsResponse;
}

type Parameter = { pageId: string };

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingRequest: HandlerType = props => {
    props.dispatch({
        type: "TrainingCalender/SetEventDetailsIsLoading",
        isLoading: true,
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getEventDetails(props.parameter.pageId);
};

export const DispatchCompleteLoadEventDetails: HandlerType = props => {
    props.dispatch({
        type: "TrainingCalender/SetEventDetails",
        data: props.apiResult?.Result,
    } as any);
};
 
export const chain = [BeginLoadingRequest, RequestDataFromApi, DispatchCompleteLoadEventDetails];

const loadEventDetails = createHandlerChainRunner(chain, "loadEventDetailsHandler");
export default loadEventDetails;
